export const namespaced = true

export const state = {
    agentStatus: null,
}

export const mutations = {
    SET_AGENT_STATUS(state, status) {
        state.agentStatus = status
    },
}

export const getters = {
    agentStatus: (s) => s.agentStatus,
}

export const actions = {
    setAgentStatus({ commit }, status) {
        commit('SET_AGENT_STATUS', status)
    },
}
